import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Button from '../../Components/Button/Button';

const PublicHeader = () => {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const closeSidebar = () => setSidebarOpen(false);

  useEffect(() => {
    if (sidebarOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [sidebarOpen]);

  const navLinks = (
    <>
      <a href="/#features" className="landing-nav-link" onClick={closeSidebar}>Features</a>
      <a href="/#how-it-works" className="landing-nav-link" onClick={closeSidebar}>How it works</a>
      <a href="/#pricing" className="landing-nav-link" onClick={closeSidebar}>Pricing</a>
    </>
  );

  const actionsContent = (
    <>
      <Link to="/login" className="landing-nav-link" onClick={closeSidebar}>Log in</Link>
      <Button
        variant="success"
        className="landing-cta-button"
        onClick={(e) => {
          e.preventDefault();
          closeSidebar();
          navigate('/choose-role');
        }}
      >
        Get started
      </Button>
    </>
  );

  return (
    <>
      <header className="landing-header">
        <div className="landing-logo">
          <Link to="/" onClick={() => localStorage.clear()}>
            <img src={window.getPublicUrl("/assets/images/Logo.png")} alt="ClearRent" className="landing-logo-img" />
          </Link>
        </div>
        <nav className="landing-nav landing-nav-desktop">
          {navLinks}
        </nav>
        <div className="landing-header-actions landing-header-actions-desktop">
          {actionsContent}
        </div>
        <button
          type="button"
          className="landing-header-toggle"
          aria-label="Open menu"
          aria-expanded={sidebarOpen}
          onClick={() => setSidebarOpen(true)}
        >
          <span className="landing-header-toggle-bar" />
          <span className="landing-header-toggle-bar" />
          <span className="landing-header-toggle-bar" />
        </button>
      </header>

      {/* Mobile sidebar overlay */}
      <div
        className={`landing-sidebar-overlay ${sidebarOpen ? 'landing-sidebar-overlay-open' : ''}`}
        aria-hidden="true"
        onClick={closeSidebar}
      />

      {/* Mobile sidebar */}
      <aside className={`landing-sidebar ${sidebarOpen ? 'landing-sidebar-open' : ''}`}>
        <div className="landing-sidebar-header">
          <button
            type="button"
            className="landing-sidebar-close"
            aria-label="Close menu"
            onClick={closeSidebar}
          >
            <span className="landing-sidebar-close-icon" />
            <span className="landing-sidebar-close-icon" />
          </button>
        </div>
        <nav className="landing-sidebar-nav">
          {navLinks}
          {actionsContent}
        </nav>
      </aside>
    </>
  );
};

export default PublicHeader;
